export default "__VITE_ASSET__c05aa059__"